import { type Composer } from "vue-i18n";
import i18n, { getCurrentLocaleLang } from "../i18n/i18n";
import { ISecurityDTO } from "../stores/security";
import { setConnectThemeIntoVuetifyLightTheme } from "./theme";

const DATE_TIME_LOCALES = ['en-US', 'de-DE', 'es-ES', 'fr-FR', 'it-IT'];

// applies locale, theme and date formats from the corvina connection: on the first load (Home) and on a
// reload of the iframe, when the security is restored from the session storage and Home is not shown
export function applyConnectSettings($vuetify: any, security: ISecurityDTO) {
  // generic composer, as returned by useI18n(): i18n.global narrows the locales to the ones with messages (only en-US)
  const composer = i18n.global as unknown as Composer;

  composer.locale.value = security.locale?.replace('_', '-') || "en-US";
  $vuetify.locale.current = getCurrentLocaleLang() || "en";

  if (security.connect?.theme) {
    setConnectThemeIntoVuetifyLightTheme(security.connect.theme, $vuetify.theme.themes.light.colors);
  }

  if (security.connect?.defaultStandardTime) {
    DATE_TIME_LOCALES.forEach(locale => composer.setDateTimeFormat(locale, security.connect!.defaultStandardTime));
  }
}
